import { React } from "react";
import Box from "@mui/material/Box";
// import { buttonBaseClasses, buttonClasses } from "@mui/material";
import MzLink from "@markaaz/ui/MzLink";

const sx = {
  root: {
    textAlign: "center",
    width: "90%"
  },
  divider: {
    borderTop: (theme) => `1px solid ${theme.palette.blue.c20}`,
    marginTop: "20px",
    marginBottom: "20px"
  },
  footer: {
    display: "flex",
    justifyContent: "flex-start",
    alignSelf: "self-end",
    margin: "0px 0px 20px 0px",
    gap: "40px"
    // [`.${buttonBaseClasses.root}.${buttonClasses.root}`]: {
    //   padding: "0px"
    // }
  }
};

function ZendeskLink(props) {
  return (
    <>
      <Box sx={sx.divider}></Box>

      <Box sx={sx.footer}>
        <MzLink href="https://developer.markaaz.com/" target="_blank">
          Developer Portal
        </MzLink>

        <MzLink href="https://markaaz.com/terms-and-conditions/" target="_blank">
          Terms & Conditions
        </MzLink>

        <MzLink href="https://markaaz.com/privacy/" target="_blank">
          Privacy Policy
        </MzLink>

        <MzLink
          onClick={() => {
            var _hsp = (window._hsp = window._hsp || []);
            _hsp.push(["showBanner"]);
          }}
        >
          Cookie Settings
        </MzLink>

        <MzLink href="https://support.markaaz.com/knowledge/business-lookup" target="_blank">
          Business Lookup FAQs
        </MzLink>
      </Box>
    </>
  );
}

export default ZendeskLink;
